import { Pipe, PipeTransform } from "@angular/core";

import { NO_IMAGE_PLACEHOLDER } from "../../common/constants";
import { isSupplierNoImagePlaceholder } from "../utils/product-image.utils";

@Pipe({
    name: "productImageSrc",
    standalone: true,
})
export class ProductImageSrcPipe implements PipeTransform {
    transform(
        preview?: string | null,
        preset: string = "thumb",
        assetId?: string | number | null,
    ): string {
        if (isSupplierNoImagePlaceholder(preview, assetId)) {
            return NO_IMAGE_PLACEHOLDER;
        }
        return `${preview!.replace(/\\/g, "/")}?preset=${preset}`;
    }
}
